import * as Yup from 'yup'
import { AtendimentoType } from '../../../../../../../../_metronic/helpers'

export const atendimentoSchema = Yup.object({
  tipoAtendimento: Yup.mixed<AtendimentoType>()
    .oneOf(Object.values(AtendimentoType))
    .required('Tipo de atendimento é obrigatório'),

  especialidade: Yup.mixed().when(['emAtendimento', 'tipoAtendimento'], {
    is: (emAtendimento: boolean, tipoAtendimento: AtendimentoType) =>
      !emAtendimento &&
      (tipoAtendimento === AtendimentoType.Assistencial ||
        tipoAtendimento === AtendimentoType.Especialista),

    then: (schema) => schema.required('Especialidade é obrigatória'),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),

  dataAtendimento: Yup.string().when('emAtendimento', {
    is: true,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required('Data de atendimento é obrigatória'),
  }),

  retorno: Yup.boolean().notRequired(),
  unidade: Yup.object().nullable().notRequired(),
  formulario: Yup.object()
    .nullable()
    .when('emAtendimento', {
      is: true,
      then: (schema) => schema.required('Selecione uma avaliação'),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  emAtendimento: Yup.boolean().required(),
})
